import { getStore } from 'core_main/store';
import { InitCallbackResponse } from './types';

export const createInitCallbackResponse = (): InitCallbackResponse => {
  const { settings } = getStore();

  const {
    embedIconUrl,
    embedIconColor,
    teamIconUrl,
    teamName,
    waitMessage,
    greeting,
    singleSessionChat,
    noHistory,
    disableAttachments,
    offhoursDisplay,
    offhoursImageUrl,
    offhoursMessage,
    closableChat,
    widgetType,
    activeAssistant,
    volumeControl,
    domainCriteria,
    colors,
    showBrandingIdentifier,
    brandId,
    knowledgeBaseId,
    assistantRules,
    sentry,
    botConsent,
    showBotIdentifier,
  } = settings;

  const { customWaitMessage } = volumeControl;

  return {
    settings: {
      embedIconUrl,
      embedIconColor,
      teamName,
      teamIconUrl,
      waitMessage: customWaitMessage || waitMessage,
      greeting,
      singleSessionChat,
      noHistory,
      disableAttachments,
      offhoursDisplay,
      offhoursImageUrl,
      offhoursMessage,
      closableChat,
      widgetType,
      activeAssistant,
      volumeControl,
      domainCriteria,
      colors,
      showBrandingIdentifier,
      brandId,
      knowledgeBaseId,
      assistantRules,
      sentry,
      botConsent,
      showBotIdentifier,
    },
  };
};
